// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"378d1973","787":"f021fffd"}[chunkId] + ".chunk.js";
};